import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import { WizardModalComponent } from '@app/shared/components';
import { Log } from 'ng2-logger';
import { Tool } from '@app/tool/model/tool.model';
import { ToolSet } from '@app/tool/model/toolSet.model';
import { ToolService } from '@services/tool.service';
import { ToolBulkReset } from '@app/tool/components/tool-bulk-reset-modal/models/tool-bulk-reset.model';

class ResetSteps {
  static SCAN = 0;
  static OVERVIEW = 1;
}

@Component({
  selector: 'app-tool-bulk-reset-modal',
  templateUrl: './tool-bulk-reset-modal.component.html',
  styleUrls: ['./tool-bulk-reset-modal.component.scss']
})
export class ToolBulkResetModalComponent implements AfterViewInit {
  _logger = Log.create(ToolBulkResetModalComponent.name);

  @ViewChild(WizardModalComponent, { static: false })
  wizardModal: WizardModalComponent;

  @Input() isLoading = false;
  @Output() onBulkReset = new EventEmitter<ToolBulkReset>();
  @Output() onClose = new EventEmitter();

  bulkReset: ToolBulkReset = new ToolBulkReset();
  selectedStep = 0;

  anyInUse = false;

  constructor(
    private cdr: ChangeDetectorRef,
    private toolService: ToolService
  ) {}

  ngAfterViewInit() {
    this.cdr.markForCheck();
  }

  open(tools: Array<ToolSet | Tool> = []) {
    this.bulkReset = new ToolBulkReset({
      tools,
      scanned: {},
    });

    const toolIds = tools.reduce<number[]>((ids, t) => {
      if ((t as ToolSet).tools) {
        ids.push(...(t as ToolSet).tools.map(child => child.id));
      } else {
        ids.push((t as Tool).id);
      }
      return ids;
    }, []);

    const dto = { toolIds };

    this.toolService.areToolsInUseBulk(dto).subscribe(inUse => {
      this.anyInUse = inUse;
      this.cdr.detectChanges();
    });

    this.wizardModal.open();
  }

  close() {
    this.reset();
    this.wizardModal.close();
    this.onClose.emit();
  }

  reset() {
    this.bulkReset = new ToolBulkReset();
  }

  onWizardSubmit() {
    if (this.allScanned) {
      this.onBulkReset.emit(this.bulkReset);
      this.close();
    }
  }

  onWizardCancel() {
    this.close();
  }

  onToolScanned(event: any) {
    const tool: Tool = event.data ? event.data : event;

    const key = tool.id ?? tool.toolUid;

    if (!key) {
      this._logger.error('Scanned tool missing both id and toolUid!', event);
      return;
    }

    this._logger.info('onToolScanned:: tool scanned', key, tool);

    this.bulkReset.scanned[key] = true;

    this.cdr.detectChanges();
  }

  get allScanned(): boolean {
    if (!this.bulkReset?.tools?.length) {
      return false;
    }

    return this.bulkReset.tools.every(t => {
      const key = (t as Tool).id ?? (t as Tool).toolUid;
      return !!this.bulkReset.scanned[key];
    });
  }


  onStepChange(stepIndex: number) {
    this.selectedStep = stepIndex;
    this._logger.info('Wizard step changed to', stepIndex);
  }
}